import React, { useEffect, useState, useCallback } from "react";
import { userRequest } from "../../requestMethods";
// Trash icon ke liye agar aap lucide-react use kar rahe ho toh use kar sakte ho
import { Trash2, RefreshCw } from "lucide-react"; 

const AdminNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("pending");

  const fetchNotifyList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await userRequest().get("product/notify-list");
      const sortedData = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setNotifications(sortedData);
    } catch (err) {
      console.error("Fetch Error:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotifyList();
  }, [fetchNotifyList]);

  const handleSendAlert = async (id) => {
    if (!window.confirm("Bhai, alert bhej kar isse history mein move kar dein?")) return;
    try {
      await userRequest().post(`product/send-restock-alert/${id}`);
      alert("🚀 Alert Sent & Record Archived!");
      fetchNotifyList();
    } catch (err) {
      alert("❌ Error: Process failed.");
    }
  };

  // 🔥 DELETE FUNCTION
  const handleDelete = async (id) => {
  if (!window.confirm("Bhai, delete kar dein?")) return;
  try {
    // Check karo 'product' ke baad slash hai ya nahi
    await userRequest().delete("product/delete-notification/${id}"); 
    alert("🗑️ Record Deleted!");
    fetchNotifyList();
  } catch (err) {
    console.log(err.response); // Isse pata chalega backend kya bol raha hai
    alert("❌ Error: Route not found or Server down.");
  }
};

  const filteredData = notifications.filter((item) => {
    const matchesSearch =
      (item.productName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.userEmail || "").toLowerCase().includes(searchTerm.toLowerCase());

    if (activeTab === "pending") {
      return matchesSearch && (item.status === "pending" || !item.status);
    } else {
      return matchesSearch && item.status === "approved";
    }
  });

  return (
    <div className="p-8 bg-[#0a0a0a] min-h-screen text-gray-300 font-sans">
      {/* Header */}
{/* --- NOTIFICATION HEADER (RESPONSIVE) --- */}
<div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 border-b border-zinc-800 pb-6 gap-6 px-2 sm:px-0">
  
  {/* LEFT SIDE: Title & Status */}
  <div className="space-y-1">
    <div className="flex items-center gap-3">
      {/* Decorative dot for mobile vibe */}
      <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse lg:hidden" />
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-white uppercase italic leading-none">
        NOTIFICATION<span className="text-emerald-500 sm:text-white">_PROTOCOLS</span>
      </h1>
    </div>
    
    <div className="flex items-center gap-2">
      <div className="hidden sm:block h-[1px] w-4 bg-emerald-500/50" />
      <p className="text-[#10b981] text-[10px] sm:text-xs font-mono uppercase tracking-[0.2em] sm:tracking-widest font-bold">
        SYSTEM_STATUS: {activeTab === "pending" ? "LIVE_QUEUE" : "ARCHIVED_HISTORY"}
      </p>
    </div>
  </div>

  {/* RIGHT SIDE: Refresh Action */}
  <button 
    onClick={fetchNotifyList} 
    disabled={loading}
    className={`
      w-full sm:w-auto px-8 py-3 sm:py-2.5 
      bg-transparent border border-emerald-500/30 
      text-[#10b981] hover:bg-emerald-500 hover:text-black 
      font-black rounded-xl sm:rounded-md 
      transition-all duration-300 text-[10px] sm:text-xs 
      tracking-[0.2em] uppercase flex items-center justify-center gap-2
      ${loading ? "opacity-50 cursor-not-allowed border-zinc-700" : "active:scale-95 shadow-[0_0_15px_rgba(16,185,129,0.1)]"}
    `}
  >
    {/* Sync icon added for better UX on mobile */}
    <RefreshCw size={14} className={`${loading ? "animate-spin" : ""}`} />
    {loading ? "SYNCING..." : "Refresh_Database"}
  </button>
</div>

      {/* Tabs */}
      <div className="flex gap-8 mb-8 border-b border-gray-900">
        <button onClick={() => setActiveTab("pending")} className={`pb-4 text-xs font-bold uppercase tracking-[0.2em] transition-all ${activeTab === "pending" ? "text-emerald-500 border-b-2 border-emerald-500" : "text-gray-600 hover:text-gray-400"}`}>
          01. Pending_Queue
        </button>
        <button onClick={() => setActiveTab("history")} className={`pb-4 text-xs font-bold uppercase tracking-[0.2em] transition-all ${activeTab === "history" ? "text-emerald-500 border-b-2 border-emerald-500" : "text-gray-600 hover:text-gray-400"}`}>
          02. Approved_History
        </button>
      </div>

      {/* Search Bar */}
      <div className="mb-8 relative max-w-xl">
        <input type="text" placeholder="FILTER_RECORDS..." className="w-full bg-[#111111] p-4 pl-12 rounded-lg border border-gray-800 focus:outline-none focus:border-emerald-500 text-sm font-mono text-emerald-400" onChange={(e) => setSearchTerm(e.target.value)} />
        <span className="absolute left-4 top-4 text-gray-600 font-mono italic">#</span>
      </div>

      {/* Cards List */}
      <div className="grid gap-4">
        {loading && notifications.length === 0 ? (
          <div className="text-center py-20 text-emerald-500 font-mono animate-pulse uppercase tracking-widest">INITIALIZING_SCAN...</div>
        ) : filteredData.length > 0 ? (
          filteredData.map((item) => (
            <div key={item._id} className={`p-5 rounded-2xl flex flex-col md:flex-row justify-between items-center transition-all border ${activeTab === 'history' ? 'bg-[#0d0d0d] border-gray-900 opacity-80' : 'bg-[#111111] border-gray-800 hover:border-emerald-500/30 shadow-xl group'}`}>
              <div className="flex gap-6 items-center w-full md:w-auto">
                <div className="w-24 h-24 bg-[#1a1a1a] rounded-xl overflow-hidden border border-gray-800 flex-shrink-0 relative">
                  {item.productImg ? (
                    <img src={item.productImg} alt="product" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" crossOrigin="anonymous"/>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-zinc-900 text-gray-700 text-[10px]">NO_IMAGE</div>
                  )}
                </div>

                <div>
                  <h3 className="text-xl font-black text-white uppercase tracking-tighter italic">{item.productName || "PRODUCT_TITLE"}</h3>
                  <p className="text-emerald-500/80 text-sm font-mono mt-0.5">{item.userEmail}</p>
                  <div className="flex flex-wrap gap-3 mt-3">
                    <span className="text-[9px] text-gray-500 font-mono border border-gray-800 px-2 py-0.5 rounded">ID: {item.productId?.slice(-8)}</span>
                  </div>
                </div>
              </div>
              
              {/* 🔥 ACTION BUTTONS SECTION (RIGHT SIDE) */}
              <div className="mt-6 md:mt-0 flex items-center gap-3">
                {activeTab === "pending" && (
                  <>
                    <button 
                      onClick={() => handleSendAlert(item._id)}
                      className="px-8 py-3 bg-emerald-500 text-black font-black uppercase text-[10px] tracking-widest rounded-lg hover:bg-white transition-all shadow-lg"
                    >
                      Send_Alert
                    </button>
                    
                    {/* 🗑️ DELETE BUTTON */}
                    <button 
                      onClick={() => handleDelete(item._id)}
                      className="p-3 bg-red-500/10 text-red-500 border border-red-500/20 rounded-lg hover:bg-red-500 hover:text-white transition-all"
                      title="Delete Record"
                    >
                      <Trash2 size={18} />
                    </button>
                  </>
                )}
                
                {activeTab === "history" && (
                  <div className="px-5 py-2 border border-emerald-500/30 text-emerald-500 text-[10px] font-mono uppercase rounded-full bg-emerald-500/5">
                    Request_Completed
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-24 border border-dashed border-gray-800 rounded-3xl">
             <p className="text-gray-600 font-mono uppercase text-xs tracking-widest">No notifications found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminNotifications;